import React from "react";

import GaugeChart from 'react-gauge-chart'

import ModulePanel from "../../ModulePanel";

const Chart = ({ satisfaction_ratio, avg_time })=>{
    const 
        avg_minutes = Math.floor(avg_time / 60),
        avg_seconds = avg_time - (avg_minutes * 60);
    return (
        <ModulePanel title={[""]}>
            <div className="d-flex align-items-center">
                <div className="text-center">
                    <GaugeChart id={`gauge_component`}
                        nrOfLevels={20}
                        textColor="#494c57"
                        percent={(satisfaction_ratio / 5)}
                        colors={["#FF0000", "#00FF00"]}
                        formatTextValue={value => `${parseInt(value)}%`} />
                    <h6>Indice de satisfacción</h6>
                </div>
                <div className="text-center">
                    <h1>{avg_minutes}m {avg_seconds}s</h1>
                    <h6>Tiempo promedio de diligenciamiento</h6>
                </div>
            </div>
        </ModulePanel>
    )
}

export default Chart;